import React, { useEffect } from 'react';
import { ViewMode } from 'packages/gannt/types';
import { ViewSwitcher } from 'pages/home/timeline/viewSwitcher';
import { Gantt } from 'packages/gannt';
import styles from './timeline.module.scss';
import { workspaceAPI } from 'pages/workspace/workspace.service';
import { KoButton, KoForm, KoLoader, KoModal, KoNano, KoText, KoTitle, KoToast } from 'packages';
import TimelineCurd from 'pages/home/timeline/curd';
import { useParams } from 'react-router';

export default function DevTimeLine() {
  const [view, setView] = React.useState(ViewMode.Day);
  const [tasks, setTasks] = React.useState();
  const [isChecked, setIsChecked] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const [isOpenCurd, setOpenCurdModal] = React.useState(false);
  const [currentTask, setCurrentTask] = React.useState(null);
  const [deleteRequest, setDeleteModal] = React.useState(false);
  let { workspaceId } = useParams();

  const [form] = KoForm.useForm();

  let columnWidth = 65;
  if (view === ViewMode.Year) {
    columnWidth = 350;
  } else if (view === ViewMode.Month) {
    columnWidth = 300;
  } else if (view === ViewMode.Week) {
    columnWidth = 250;
  }

  useEffect(() => {
    getTasks(workspaceId);
  }, [workspaceId]);


  const fixDates = tasks =>
    tasks.map(t => ({
      ...t,
      start: new Date(t.start),
      end: new Date(t.end)
    }));

  const getTasks = (workspaceId) => {
    setLoading(true);
    workspaceAPI.getTasks(workspaceId).then(
      (data) => {
        setTasks(fixDates(data['timelines']||[]));
        setOpenCurdModal(false);
        form.resetFields();
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };



  const handleTaskChange = (task) => {
    let newTasks = tasks.map((t) => (t.id === task.id ? task : t));
    setTasks(newTasks);
    handleSubmit(task);
  };

  const handleTaskDelete = (task) => {
    setTasks(tasks.filter((t) => t.id !== task.id));
    workspaceAPI.deleteTask(task.id, workspaceId).then(
      (data) => {
        KoToast.success(`Task deleted successfully!`);
        getTasks(workspaceId);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const handleProgressChange = async(task) => {
    setTasks(tasks.map((t) => (t.id === task.id ? task : t)));
    handleSubmit(task);
    console.log("On progress change Id:", JSON.stringify(tasks));
  };

  const handleDblClick = (task) => {
    // setOpenCurdModal(true);
  };

  const handleClick = (task) => {
    console.log("On Click event Id:" + task.id);
    setCurrentTask();
    setTimeout(() => {
      form.setFieldsValue(task);
      setCurrentTask(task);
      setOpenCurdModal(true);
    }, 10);
   
  };

  const handleSelect = (task, isSelected) => {
    console.log(
      task.name + " has " + (isSelected ? "selected" : "unselected")
    );
  };

  const handleExpanderClick = (task) => {
    setTasks(tasks.map((t) => (t.id === task.id ? task : t)));
    console.log("On expander click Id:" + task.id);
    handleSubmit(task);
  };

  const handleSubmit = (values) => {
    setLoading(true);
    if(!values['id']){
      values['id'] = KoNano('TSL');
    }
    workspaceAPI.createTask(values, workspaceId, currentTask?.id).then(
      (data) => {
        setLoading(false);
        getTasks(workspaceId);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const onInit = (api) => {
    setTimeout(() => {
      form.setFieldsValue({});
      setCurrentTask();
      setOpenCurdModal(true);
    }, 10);
   
  };

  return (
    <div className={styles.wrapper}>
      {loading && <KoLoader />}
      <svg
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          inset: 0
        }}
      >
        <defs>
          <pattern
            id="pattern-hero"
            width="20"
            height="20"
            x="0"
            y="0"
            patternUnits="userSpaceOnUse"
            patternTransform="translate(-11,-11)"
          >
            <circle cx="1" cy="1" r="1" fill="#ccc" />
          </pattern>
        </defs>

        <rect width="100%" height="100%" fill="url(#pattern-hero)" />
      </svg>

      <ViewSwitcher
        onViewModeChange={(viewMode) => setView(viewMode)}
        onViewListChange={setIsChecked}
        isChecked={isChecked}
        viewMode={view}
        setOpenCurdModal={(value) => {form.resetFields(); onInit(value);}}
      />
    
      <div className={styles.gantt}>
        {tasks && tasks.length > 0 && <Gantt
          tasks={tasks}
          viewMode={view}
          onDateChange={handleTaskChange}
          // onDelete={handleTaskDelete}
          onProgressChange={handleProgressChange}
          onDoubleClick={handleDblClick}
          onClick={handleClick}
          onSelect={handleSelect}
          onExpanderClick={handleExpanderClick}
          listCellWidth={false}
          columnWidth={columnWidth}
        />}
      </div>
     
      <KoModal
        centered
        title={currentTask?.id ? 'Update Task' : 'Create Task'}
        open={isOpenCurd}
        handleOk={() => { setOpenCurdModal(false); }}
        onClose={() => { setOpenCurdModal(false); }}
        width={'50vw'}
        footer={[
          <KoButton key='cancel' label='Close' onClick={() => setOpenCurdModal(false)} />,
          <KoButton key='delete' label='Delete' type='primary' danger onClick={() => setDeleteModal(true)} />,
          <KoButton key='submit' label={currentTask?.id ? 'Update' : 'Create'} type='primary' onClick={() => form.submit()}/>
        ]}
      >
        <TimelineCurd form={form} tasks={tasks} initialValues={currentTask} handleSubmit={handleSubmit} />
      </KoModal>

      <KoModal
        title={`Delete Task`}
        centered
        open={deleteRequest}
        afterClose={() => { setCurrentTask(); }}
        handleOk={() => { setCurrentTask(); setDeleteModal(false); }}
        onClose={() => { setCurrentTask(); setDeleteModal(false); }}
        width={580}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setDeleteModal(false)} />,
          <KoButton key='reset' color="danger" variant="solid" type='primary' label='Delete' onClick={() => handleTaskDelete(currentTask)} />
        ]}
      >
        {loading && <KoLoader circle={false} />}
        <div className={styles.suspend}>
          <KoTitle level={5} text={`Are you sure you want to delete this task?`} />
          <KoText text={`This action is irreversible, and it will result in the removal of their associated data.`} />
        </div>
      </KoModal>

    </div>
  );
}